import Tile from "ol/layer/Tile";
import XYZ from "ol/source/XYZ.js";

const mapboxKey =
  "pk.eyJ1IjoiamFudXN6ZXgiLCJhIjoiY2sxMXp4ZTZrMDNkNTNncXk5ZzV4bjhyeiJ9.BLLvyGGQ7b6q1xep-j4fZQ";

const hereKey = "j2gy9Cl4TICEp2-Odta1HKIKooURckuejsowdheY3WI"

export const basemaps = [
  new Tile({
    source: new XYZ({
      url: `https://maps.hereapi.com/v3/base/mc/{z}/{x}/{y}/png8?style=explore.day&apiKey=${hereKey}`,
      attributions: `Map Tiles &copy; ${new Date().getFullYear()} <a href="http://developer.here.com">HERE</a>`,
      crossOrigin: "Anonymous"
    }),
    visible: true,
    name: "HereStreets",
    group: "baselayers"
  }),
  new Tile({
    source: new XYZ({
      url: `https://maps.hereapi.com/v3/base/mc/{z}/{x}/{y}/png8?style=satellite.day&apiKey=${hereKey}`,
      attributions: `Map Tiles &copy; ${new Date().getFullYear()} <a href="http://developer.here.com">HERE</a>`,
      crossOrigin: "Anonymous"
    }),
    visible: false,
    name: "HereSatellite",
    group: "baselayers"
  }),
  new Tile({
    source: new XYZ({
      url: `https://maps.hereapi.com/v3/base/mc/{z}/{x}/{y}/png8?style=explore.satellite.day&apiKey=${hereKey}`,
      attributions: `Map Tiles &copy; ${new Date().getFullYear()} <a href="http://developer.here.com">HERE</a>`,
      crossOrigin: "Anonymous"
    }),
    visible: true,
    name: "HereHybrid",
    group: "baselayers"
  }),
  new Tile({
    source: new XYZ({
      url: `https://api.mapbox.com/styles/v1/mapbox/light-v9/tiles/256/{z}/{x}/{y}?access_token=${mapboxKey}`,
      crossOrigin: "Anonymous"
    }),
    visible: false,
    name: "MapboxLight",
    group: "baselayers"
  }),
  new Tile({
    source: new XYZ({
      url: `https://api.mapbox.com/styles/v1/mapbox/satellite-v9/tiles/256/{z}/{x}/{y}?access_token=${mapboxKey}`,
      crossOrigin: "Anonymous"
    }),
    visible: false,
    name: "MapboxSatellite",
    group: "baselayers"
  }),
  new Tile({
    source: new XYZ({
      url: `https://api.mapbox.com/styles/v1/mapbox/satellite-streets-v9/tiles/256/{z}/{x}/{y}?access_token=${mapboxKey}`,
      crossOrigin: "Anonymous"
    }),
    visible: false,
    name: "MapboxHybrid",
    group: "baselayers"
  })
];
